import script from "./vipPurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipPurchase.vue?vue&type=script&setup=true&lang=ts"

import "./vipPurchase.vue?vue&type=style&index=0&id=13c0b144&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c0b144"]])

export default __exports__